import React, { FC } from "react";
import { FormField } from "Components/Shared/FormComponents/FormField/FormField";
import AmountField from "Components/Shared/FormComponents/AmountField/AmountField";

type Props = {
  remainingRewardBudget: number;
};

export const RewardAmountField: FC<Props> = ({ remainingRewardBudget }) => {
  return (
    <FormField fieldName="Reward Amount ($)">
      <AmountField name="amount" maxAmount={remainingRewardBudget} />
    </FormField>
  );
};
